//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectBodyList.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../Routing/Routing.SelectPortList.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/LineWelds.js";
import "../no/NXObject.js";
import "../no/RoutingCommon.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Associative",1,0],[1,"ConnectedBodies",0,"SelectBodyList",0],[0,"CustomAttributesHolder",0,"TaggedObject",0],[0,"DelayUpdate",1,0],[0,"Destination",1,0],[1,"DistanceTolerance",0,"Expression",0],[1,"InheritFeature",0,"SelectNXObject",0],[0,"Material",1,"TaggedObject",0],[1,"MaterialActualThickness",0,"Expression",0],[0,"MaterialAssignmentPolicy",1,0],[1,"MaterialDispensedWidth",0,"Expression",0],[1,"NuggetDiameter",0,"Expression",0],[1,"PortSelect",0,"Routing.SelectPortList",0],[0,"PreventDuplicates",1,0],[1,"RoutingComponents",0,"Assemblies.SelectComponentList",0],[0,"RoutingConnectionType",1,0],[0,"RoutingCreateMode",1,0],[0,"ShowConnectedBodies",1,0],[0,"Subtype",1,0],[0,"TwoPointWeld",1,0],[0,"WeldFinishMethod",1,0]],[[["status"],"SetShowThroughState",{},1,0],[["hideSolid"],"SetHideSolid",{},1,0],[["nBodies"],"GetJoinBodies",{R_:{joinBodies:"Body[]"}},0,0],[["waveLink"],"AddNewlyCreatedWaveLink",{},1,0],[["nParts","parts"],"GetPortComponents",{},0,0],[["file"],"SetCallbackFile",{},1,0],[["title"],"GetCustomAttributeType",{R_:{type:''}},1,0],[["formula"],"EvaluateFormula",{R_:{formulaResult:''}},1,0]],[]];
SPLM.Join.JoinBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.JoinBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Join.JoinBuilder.MaterialAssignmentPolicyType = Object.freeze({
    "NoneAssigned" : "NoneAssigned", "ExternallyAssigned" : "ExternallyAssigned", "JoinFeatureAssigned" : "JoinFeatureAssigned"});

SPLM.Join.JoinBuilder.DestinationTypes = Object.freeze({
    "WorkPart" : "WorkPart", "NewComponent" : "NewComponent"});

SPLM.Join.JoinBuilder.RoutingCreateModeTypes = Object.freeze({
    "SingleFeature" : "SingleFeature", "MultipleFeatures" : "MultipleFeatures"});

export default SPLM;